export default "__VITE_ASSET__Bg8dxOdu__"